import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DE, ES, US, FR } from 'country-flag-icons/react/3x2';

type props = {
  type: string;
};

const FlagComponent = ({ type }: props) => {
  if (type === 'es') {
    return <ES title="Español" className="lang-flag" />;
  }
  if (type === 'de') {
    return <DE title="Deutsch" className="lang-flag" />;
  }
  if (type === 'fr') {
    return <FR title="Français" className="lang-flag" />;
  }

  return <US title="English" className="lang-flag" />;
};

const LangChooser = () => {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem('affogato-lang') || 'es',
  );

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('affogato-lang', lang);
    setCurrentLang(lang);
  };

  const handleOnSelect = (eventKey: any, event: Object) => {
    changeLanguage(eventKey);
    setCurrentLang(eventKey);
  };

  const LangBar = () => (
    <div className="fixed bottom-4 right-4 z-50 flex items-center bg-white/80 backdrop-blur-md shadow-xl rounded-full p-1 border border-white/40 gap-1">
      <button
        className={`w-10 h-10 flex items-center justify-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 ${currentLang === 'es' ? 'bg-amber-100' : 'hover:bg-gray-100/50'}`}
        onClick={() => changeLanguage('es')}
        aria-label="Español"
        aria-current={currentLang === 'es' ? 'true' : undefined}
      >
        <ES title="Español" className="w-6 rounded-sm shadow-sm" />
      </button>
      <button
        className={`w-10 h-10 flex items-center justify-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 ${currentLang === 'en' ? 'bg-amber-100' : 'hover:bg-gray-100/50'}`}
        onClick={() => changeLanguage('en')}
        aria-label="English"
        aria-current={currentLang === 'en' ? 'true' : undefined}
      >
        <US title="English" className="w-6 rounded-sm shadow-sm" />
      </button>
      <button
        className={`w-10 h-10 flex items-center justify-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 ${currentLang === 'de' ? 'bg-amber-100' : 'hover:bg-gray-100/50'}`}
        onClick={() => changeLanguage('de')}
        aria-label="Deutsch"
        aria-current={currentLang === 'de' ? 'true' : undefined}
      >
        <DE title="Deutsch" className="w-6 rounded-sm shadow-sm" />
      </button>
      <button
        className={`w-10 h-10 flex items-center justify-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 ${currentLang === 'fr' ? 'bg-amber-100' : 'hover:bg-gray-100/50'}`}
        onClick={() => changeLanguage('fr')}
        aria-label="Français"
        aria-current={currentLang === 'fr' ? 'true' : undefined}
      >
        <FR title="Français" className="w-6 rounded-sm shadow-sm" />
      </button>
    </div>
  );

  return <>{LangBar()}</>;
};

export default LangChooser;
